module.exports = __webpack_public_path__ + "img/carryall_packed.ca7149b2.jpg";